import React from 'react';
import { AgentLister } from './AgentLister';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

interface AgentReportPageProps {
  onBack: () => void;
}

export function AgentReportPage({ onBack }: AgentReportPageProps) {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="sticky top-0 z-10 bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-white/10">
        <div className="container mx-auto px-4 py-4">
          <Button
            variant="ghost"
            onClick={onBack}
            className="text-[#FDB022] hover:text-[#FDB022]/80"
            data-testid="agent-report-page-back-button"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Admin Hub
          </Button>
        </div>
      </div>
      <div className="container mx-auto">
        <AgentLister />
      </div>
    </div>
  );
}
